import { Inject, Injectable } from '@angular/core';
import * as $ from "jquery";
import { ILUserDetails, IUser, userDetails, APIKeyDetails } from 'src/app/login/user.model';
import { RoleModules } from 'src/app/login/role.model';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class Globals {
public GOOGLE_MAPS_API_KEY: string = environment.GOOGLE_MAPS_API_KEY;
    public TOKENPOINT: string = "";
    public App_Context: String = "";
    public URLPREFIX: string = "";
    public CONTEXT_PATH: string = "";
    public environmentVariables = [];
    public selectedEnv: string = "";
    public BACKEND_URL_PREFIX: string = "";
    public REDIRECTION_URL_PREFIX: string = "";
    public EAPPS_URL_PREFIX: string = "";
    public EAPPS_CONTEXT_PATH: string = "";
    public EKYC_CONTEXT_PATH: string = "";
    public EKYC_URL_PREFIX: string = "";
    public MSG_REDIRECTION_URL_PREFIX: string = "";
    public EAPPS_RENEWAL_BULK_DOWNLOAD: string = "";
    public MEDICARE_TPA_URL: string = "";
    public PARAMOUNT_TPA_URL: string = "";
    public PAYMENTGW: string = "";
    public VCONNECT_CONTEXT_PATH: string = "";
    public VCONNECT_BACKEND_URL_PREFIX: string = "";
    public IPOLICY_BACKEND_URL_PREFIX: string = "";
    public D2C_CONTEXT_PATH: string = "";
    public D2C_BACKEND_URL_PREFIX: string = "";
    public COMMERCIAL_URL: string = "";
    public D2C_ONPREMISE_CONTEXT_PATH: string = "";
    public D2C_ONPREMISE_BACKEND_URL_PREFIX: string = "";
    today = new Date();
    agelimitdate1= new Date();
    public CHAT_BOT_URL: string = "";
    public CPM_URL: string = "";
    //code related to EAPPS menu
    public enableMotorSearch: boolean = false;
    public enableTravelhealthSearch: boolean = false;
    public enableHealthSearch: boolean = false;
    public enableHomeSearch: boolean = false;
    public enableTravelSearch: boolean = false;
    enableManufacturerModule: boolean = false;
    public enabeGroupCovidTab: boolean = false;
    public enableCPA = false;
    public enableHealthPolicy: boolean = false;
    public enableTravelhealthPolicy: boolean = false;
    public enableTravelhealthQuickCal: boolean = false;
    public EnableMotor = false;
    public enableIssueMotorSelfPolicy: boolean = false;
    public enableIssueMotorBehalfPolicy: boolean = false;
    public enableIssueHomePolicy: boolean = false;
    public enableIssueTravelPolicy: boolean = false;
    public ROLE_ISSUANCE_RESTRICTION:boolean = false;
    public enableRatingCalculator: boolean = false;
    public enableReceipts: boolean = false;
    public sahaj_user: boolean = false;
    public enableIPolicyMenu: boolean = false;
    public from:string='';
    public showOrHideSideMenu: boolean = false;
    public encryptionReq = true;
    public isEncryption = 'Yes';
    public NEXUS_PORTAL_URL : any = "";
    public enableCarPoilcy = false;
    public enablePayInSlip = false;
    public enableAutoReceiptRole = false;
    public simpleInwardlink = false
    public IPOLICYV2_URL_PREFIX = "";
    public UDAYAN_URL_PREFIX = "";
    public IS_MOBILE_CLEVERTAP_ENABLE = false;
    public RUM_DATADOG: any = {};
    public EPICX_AI_URL: any;
    public Key_IV : any;
    public PASSWORD : any;
    public SALT : any;
    public OAUTH2_ROYALSUNDARAM : string = "";
    public VCONNECT_Key_IV : any;
    public VCONNECT_SHARED_KEY : any;
    public IOS_URL : any;
    public ANDROID_URL : any;
    private sanitizer = Inject(DomSanitizer);
    constructor() {
      this.agelimitdate1.setFullYear(this.agelimitdate1.getFullYear()-18);

        this.selectedEnv = environment.selectedEnv;
        this.App_Context = environment.context;
        this.enableCPA = environment.enableCPA;
        this.EnableMotor = environment.enableMotor;
        this.enableManufacturerModule = environment.enableManufacturerModule;
        this.enableIPolicyMenu = environment.enableIPolicyMenu;
        this.BACKEND_URL_PREFIX = window.location.origin+'/';
        //this.BACKEND_URL_PREFIX = "http://rsgitstm96:19090/"
        // this.BACKEND_URL_PREFIX = "http://localhost:8090/";
        //  this.BACKEND_URL_PREFIX = "http://10.170.12.67:8090/";
        // this.BACKEND_URL_PREFIX = "http://rsgitstm05:9090/";
        //this.BACKEND_URL_PREFIX = "https://www.royalsundaram.net/"
        this.IOS_URL = environment.IOS_URL;
        this.ANDROID_URL = environment.ANDROID_URL;
                             
        if(window.location.protocol.includes('https')){
            if(this.selectedEnv == 'UAT'){
                this.CONTEXT_PATH = environment.UAT_Ext.CONTEXT_PATH;
                this.REDIRECTION_URL_PREFIX = environment.UAT_Ext.REDIRECTION_URL_PREFIX
                this.EAPPS_CONTEXT_PATH = environment.UAT_Ext.EAPPS_CONTEXT_PATH;
                this.EKYC_CONTEXT_PATH = environment.UAT_Ext.EKYC_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.UAT_Ext.EAPPS_URL_PREFIX;
                this.MSG_REDIRECTION_URL_PREFIX = environment.UAT_Ext.MSG_REDIRECTION_URL_PREFIX;
                this.EAPPS_RENEWAL_BULK_DOWNLOAD = environment.UAT_Ext.EAPPS_RENEWAL_BULK_DOWNLOAD;
                this.MEDICARE_TPA_URL = environment.UAT_Ext.MEDICARE_TPA_URL;
                this.PARAMOUNT_TPA_URL = environment.UAT_Ext.PARAMOUNT_TPA_URL;
                this.VCONNECT_CONTEXT_PATH = environment.UAT_Ext.VCONNECT_CONTEXT_PATH;
                this.VCONNECT_BACKEND_URL_PREFIX = environment.UAT_Ext.VCONNECT_BACKEND_URL_PREFIX;
                this.IPOLICY_BACKEND_URL_PREFIX = environment.UAT_Ext.IPOLICY_BACKEND_URL_PREFIX;
                this.D2C_CONTEXT_PATH = environment.UAT_Ext.D2C_CONTEXT_PATH;
                this.D2C_BACKEND_URL_PREFIX = environment.UAT_Ext.D2C_BACKEND_URL_PREFIX;
                this.CHAT_BOT_URL = environment.UAT_Ext.CHAT_BOT_URL;
                this.COMMERCIAL_URL = environment.UAT_Ext.COMMERCIAL_URL;
                this.EKYC_URL_PREFIX = environment.UAT_Ext.EKYC_URL_PREFIX;
                this.D2C_ONPREMISE_CONTEXT_PATH = environment.UAT_Ext.D2C_ONPREMISE_CONTEXT_PATH;
                this.D2C_ONPREMISE_BACKEND_URL_PREFIX = environment.UAT_Ext.D2C_ONPREMISE_BACKEND_URL_PREFIX;
                this.PAYMENTGW = environment.UAT_Ext.PAYMENTGW;
                this.NEXUS_PORTAL_URL = environment.UAT_Ext.NEXUS_PORTAL_URL;
                this.IPOLICYV2_URL_PREFIX = environment.UAT_Ext.IPOLICYV2_URL_PREFIX;
                this.CPM_URL = environment.UAT_Ext.CPM_URL;
                this.UDAYAN_URL_PREFIX = environment.UAT_Ext.UDAYAN_URL_PREFIX;
                this.EPICX_AI_URL = environment.UAT_Ext.EPICX_AI_URL;
                // this.BACKEND_URL_PREFIX = environment.UAT_Ext.BACKEND_URL_PREFIX;
               
                
            }
            if(this.selectedEnv == 'LIVE'){
                this.CONTEXT_PATH = environment.LIVE_Ext.CONTEXT_PATH;
                this.REDIRECTION_URL_PREFIX = environment.LIVE_Ext.REDIRECTION_URL_PREFIX
                this.EAPPS_CONTEXT_PATH = environment.LIVE_Ext.EAPPS_CONTEXT_PATH;
                this.EKYC_CONTEXT_PATH = environment.LIVE_Ext.EKYC_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.LIVE_Ext.EAPPS_URL_PREFIX;
                this.MSG_REDIRECTION_URL_PREFIX = environment.LIVE_Ext.MSG_REDIRECTION_URL_PREFIX;
                this.EAPPS_RENEWAL_BULK_DOWNLOAD = environment.LIVE_Ext.EAPPS_RENEWAL_BULK_DOWNLOAD;
                this.MEDICARE_TPA_URL = environment.LIVE_Ext.MEDICARE_TPA_URL;
                this.PARAMOUNT_TPA_URL = environment.LIVE_Ext.PARAMOUNT_TPA_URL;
                this.VCONNECT_CONTEXT_PATH = environment.LIVE_Ext.VCONNECT_CONTEXT_PATH;
                this.VCONNECT_BACKEND_URL_PREFIX = environment.LIVE_Ext.VCONNECT_BACKEND_URL_PREFIX;
                this.IPOLICY_BACKEND_URL_PREFIX = environment.LIVE_Ext.IPOLICY_BACKEND_URL_PREFIX;
                this.D2C_CONTEXT_PATH = environment.LIVE_Ext.D2C_CONTEXT_PATH;
                this.D2C_BACKEND_URL_PREFIX = environment.LIVE_Ext.D2C_BACKEND_URL_PREFIX;
                this.COMMERCIAL_URL = environment.LIVE_Ext.COMMERCIAL_URL;
                this.CHAT_BOT_URL = environment.LIVE_Ext.CHAT_BOT_URL;
                this.EKYC_URL_PREFIX = environment.LIVE_Ext.EKYC_URL_PREFIX;
                this.D2C_ONPREMISE_CONTEXT_PATH = environment.LIVE_Ext.D2C_ONPREMISE_CONTEXT_PATH;
                this.D2C_ONPREMISE_BACKEND_URL_PREFIX = environment.LIVE_Ext.D2C_ONPREMISE_BACKEND_URL_PREFIX;
                this.PAYMENTGW = environment.LIVE_Ext.PAYMENTGW;
                this.NEXUS_PORTAL_URL = environment.LIVE_Ext.NEXUS_PORTAL_URL;
                this.IPOLICYV2_URL_PREFIX = environment.LIVE_Ext.IPOLICYV2_URL_PREFIX;
                this.CPM_URL = environment.LIVE_Ext.CPM_URL;
                this.EPICX_AI_URL = environment.LIVE_Ext.EPICX_AI_URL;
                // this.BACKEND_URL_PREFIX = environment.LIVE_Ext.BACKEND_URL_PREFIX;
            }
        }else{
            if(this.selectedEnv == 'UAT'){
                this.CONTEXT_PATH = environment.UAT.CONTEXT_PATH;
                this.REDIRECTION_URL_PREFIX = environment.UAT.REDIRECTION_URL_PREFIX
                this.EAPPS_CONTEXT_PATH = environment.UAT.EAPPS_CONTEXT_PATH;
                this.EKYC_CONTEXT_PATH = environment.UAT.EKYC_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.UAT.EAPPS_URL_PREFIX;
                this.MSG_REDIRECTION_URL_PREFIX = environment.UAT.MSG_REDIRECTION_URL_PREFIX;
                this.EAPPS_RENEWAL_BULK_DOWNLOAD = environment.UAT.EAPPS_RENEWAL_BULK_DOWNLOAD;
                this.MEDICARE_TPA_URL = environment.UAT.MEDICARE_TPA_URL;
                this.PARAMOUNT_TPA_URL = environment.UAT.PARAMOUNT_TPA_URL;
                this.VCONNECT_CONTEXT_PATH = environment.UAT.VCONNECT_CONTEXT_PATH;
                this.VCONNECT_BACKEND_URL_PREFIX = environment.UAT.VCONNECT_BACKEND_URL_PREFIX;
                this.IPOLICY_BACKEND_URL_PREFIX = environment.UAT.IPOLICY_BACKEND_URL_PREFIX;
                this.D2C_CONTEXT_PATH = environment.UAT.D2C_CONTEXT_PATH;
                this.D2C_BACKEND_URL_PREFIX = environment.UAT.D2C_BACKEND_URL_PREFIX;
                this.CHAT_BOT_URL = environment.UAT.CHAT_BOT_URL;
                this.COMMERCIAL_URL = environment.UAT.COMMERCIAL_URL;
                this.EKYC_URL_PREFIX = environment.UAT.EKYC_URL_PREFIX;
                this.encryptionReq = true;
                this.isEncryption = 'Yes';
                this.D2C_ONPREMISE_CONTEXT_PATH = environment.UAT.D2C_ONPREMISE_CONTEXT_PATH;
                this.D2C_ONPREMISE_BACKEND_URL_PREFIX = environment.UAT.D2C_ONPREMISE_BACKEND_URL_PREFIX;
                this.PAYMENTGW = environment.UAT.PAYMENTGW;
                this.NEXUS_PORTAL_URL = environment.UAT.NEXUS_PORTAL_URL;
                this.IPOLICYV2_URL_PREFIX = environment.UAT.IPOLICYV2_URL_PREFIX;
                this.CPM_URL = environment.UAT.CPM_URL;
                this.UDAYAN_URL_PREFIX = environment.UAT.UDAYAN_URL_PREFIX;
                this.EPICX_AI_URL = environment.UAT.EPICX_AI_URL;
                // this.BACKEND_URL_PREFIX = environment.UAT.BACKEND_URL_PREFIX;
         
            }
            if(this.selectedEnv == 'PreLive'){
                this.CONTEXT_PATH = environment.PreLive.CONTEXT_PATH;
                this.REDIRECTION_URL_PREFIX = environment.PreLive.REDIRECTION_URL_PREFIX
                this.EAPPS_CONTEXT_PATH = environment.PreLive.EAPPS_CONTEXT_PATH;
                this.EKYC_CONTEXT_PATH = environment.PreLive.EKYC_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.PreLive.EAPPS_URL_PREFIX;
                this.MSG_REDIRECTION_URL_PREFIX = environment.PreLive.MSG_REDIRECTION_URL_PREFIX;
                this.EAPPS_RENEWAL_BULK_DOWNLOAD = environment.PreLive.EAPPS_RENEWAL_BULK_DOWNLOAD;
                this.MEDICARE_TPA_URL = environment.PreLive.MEDICARE_TPA_URL;
                this.PARAMOUNT_TPA_URL = environment.PreLive.PARAMOUNT_TPA_URL;
                this.VCONNECT_CONTEXT_PATH = environment.PreLive.VCONNECT_CONTEXT_PATH;
                this.VCONNECT_BACKEND_URL_PREFIX = environment.PreLive.VCONNECT_BACKEND_URL_PREFIX;
                this.IPOLICY_BACKEND_URL_PREFIX = environment.PreLive.IPOLICY_BACKEND_URL_PREFIX;
                this.D2C_CONTEXT_PATH = environment.PreLive.D2C_CONTEXT_PATH;
                this.D2C_BACKEND_URL_PREFIX = environment.PreLive.D2C_BACKEND_URL_PREFIX;
                this.COMMERCIAL_URL = environment.PreLive.COMMERCIAL_URL;
                this.CHAT_BOT_URL = environment.PreLive.CHAT_BOT_URL;
                this.EKYC_URL_PREFIX = environment.PreLive.EKYC_URL_PREFIX;
                this.encryptionReq = true;
                this.isEncryption = 'Yes';
                this.D2C_ONPREMISE_CONTEXT_PATH = environment.PreLive.D2C_ONPREMISE_CONTEXT_PATH;
                this.D2C_ONPREMISE_BACKEND_URL_PREFIX = environment.PreLive.D2C_ONPREMISE_BACKEND_URL_PREFIX;
                this.PAYMENTGW = environment.PreLive.PAYMENTGW;
                this.NEXUS_PORTAL_URL = environment.PreLive.NEXUS_PORTAL_URL;
                this.IPOLICYV2_URL_PREFIX = environment.PreLive.IPOLICYV2_URL_PREFIX;
                this.CPM_URL = environment.PreLive.CPM_URL;
                this.EPICX_AI_URL = environment.PreLive.EPICX_AI_URL;
                // this.BACKEND_URL_PREFIX = environment.PreLive.BACKEND_URL_PREFIX;
            }
            if(this.selectedEnv == 'LIVE'){
                this.CONTEXT_PATH = environment.LIVE.CONTEXT_PATH;
                this.REDIRECTION_URL_PREFIX = environment.LIVE.REDIRECTION_URL_PREFIX
                this.EAPPS_CONTEXT_PATH = environment.LIVE.EAPPS_CONTEXT_PATH;
                this.EKYC_CONTEXT_PATH = environment.LIVE.EKYC_CONTEXT_PATH;
                this.EAPPS_URL_PREFIX = environment.LIVE.EAPPS_URL_PREFIX;
                this.MSG_REDIRECTION_URL_PREFIX = environment.LIVE.MSG_REDIRECTION_URL_PREFIX;
                this.EAPPS_RENEWAL_BULK_DOWNLOAD = environment.LIVE.EAPPS_RENEWAL_BULK_DOWNLOAD;
                this.MEDICARE_TPA_URL = environment.LIVE.MEDICARE_TPA_URL;
                this.PARAMOUNT_TPA_URL = environment.LIVE.PARAMOUNT_TPA_URL;
                this.VCONNECT_CONTEXT_PATH = environment.LIVE.VCONNECT_CONTEXT_PATH;
                this.VCONNECT_BACKEND_URL_PREFIX = environment.LIVE.VCONNECT_BACKEND_URL_PREFIX;
                this.IPOLICY_BACKEND_URL_PREFIX = environment.LIVE.IPOLICY_BACKEND_URL_PREFIX;
                this.D2C_CONTEXT_PATH = environment.LIVE.D2C_CONTEXT_PATH;
                this.D2C_BACKEND_URL_PREFIX = environment.LIVE.D2C_BACKEND_URL_PREFIX;
                this.COMMERCIAL_URL = environment.LIVE.COMMERCIAL_URL;
                this.CHAT_BOT_URL = environment.LIVE.CHAT_BOT_URL;
                this.EKYC_URL_PREFIX = environment.LIVE.EKYC_URL_PREFIX;
                this.encryptionReq = true;
                this.isEncryption = 'Yes';
                this.D2C_ONPREMISE_CONTEXT_PATH = environment.LIVE.D2C_ONPREMISE_CONTEXT_PATH;
                this.D2C_ONPREMISE_BACKEND_URL_PREFIX = environment.LIVE.D2C_ONPREMISE_BACKEND_URL_PREFIX;
                this.PAYMENTGW = environment.LIVE.PAYMENTGW;
                this.NEXUS_PORTAL_URL = environment.LIVE.NEXUS_PORTAL_URL;
                this.IPOLICYV2_URL_PREFIX = environment.LIVE.IPOLICYV2_URL_PREFIX;
                this.CPM_URL = environment.LIVE.CPM_URL;
                this.EPICX_AI_URL = environment.LIVE.EPICX_AI_URL;
                // this.BACKEND_URL_PREFIX = environment.LIVE.BACKEND_URL_PREFIX;
            }
            if(this.selectedEnv == 'PreUAT'){
              this.CONTEXT_PATH = environment.PreUAT.CONTEXT_PATH;
              this.REDIRECTION_URL_PREFIX = environment.PreUAT.REDIRECTION_URL_PREFIX
              this.EAPPS_CONTEXT_PATH = environment.PreUAT.EAPPS_CONTEXT_PATH;
              this.EKYC_CONTEXT_PATH = environment.PreUAT.EKYC_CONTEXT_PATH;
              this.EAPPS_URL_PREFIX = environment.PreUAT.EAPPS_URL_PREFIX;
              this.MSG_REDIRECTION_URL_PREFIX = environment.PreUAT.MSG_REDIRECTION_URL_PREFIX;
              this.EAPPS_RENEWAL_BULK_DOWNLOAD = environment.PreUAT.EAPPS_RENEWAL_BULK_DOWNLOAD;
              this.MEDICARE_TPA_URL = environment.PreUAT.MEDICARE_TPA_URL;
              this.PARAMOUNT_TPA_URL = environment.PreUAT.PARAMOUNT_TPA_URL;
              this.VCONNECT_CONTEXT_PATH = environment.PreUAT.VCONNECT_CONTEXT_PATH;
              this.VCONNECT_BACKEND_URL_PREFIX = environment.PreUAT.VCONNECT_BACKEND_URL_PREFIX;
              this.IPOLICY_BACKEND_URL_PREFIX = environment.PreUAT.IPOLICY_BACKEND_URL_PREFIX;
              this.D2C_CONTEXT_PATH = environment.PreUAT.D2C_CONTEXT_PATH;
              this.D2C_BACKEND_URL_PREFIX = environment.PreUAT.D2C_BACKEND_URL_PREFIX;
              this.CHAT_BOT_URL = environment.PreUAT.CHAT_BOT_URL;
              this.COMMERCIAL_URL = environment.PreUAT.COMMERCIAL_URL;
              this.EKYC_URL_PREFIX = environment.PreUAT.EKYC_URL_PREFIX;
              this.encryptionReq = true;
              this.isEncryption = 'Yes';
              this.D2C_ONPREMISE_CONTEXT_PATH = environment.PreUAT.D2C_ONPREMISE_CONTEXT_PATH;
              this.D2C_ONPREMISE_BACKEND_URL_PREFIX = environment.PreUAT.D2C_ONPREMISE_BACKEND_URL_PREFIX;
              this.PAYMENTGW = environment.PreUAT.PAYMENTGW;
              this.NEXUS_PORTAL_URL = environment.PreUAT.NEXUS_PORTAL_URL;
              this.IPOLICYV2_URL_PREFIX = environment.PreUAT.IPOLICYV2_URL_PREFIX;
              this.CPM_URL = environment.PreUAT.CPM_URL;
              this.UDAYAN_URL_PREFIX = environment.PreUAT.UDAYAN_URL_PREFIX;
              this.EPICX_AI_URL = environment.PreUAT.EPICX_AI_URL;
            //   this.BACKEND_URL_PREFIX = environment.PreUAT.BACKEND_URL_PREFIX;
          
          }
          if(this.selectedEnv == 'apk_UAT'){
            this.CONTEXT_PATH = environment.apk_UAT.CONTEXT_PATH;
            this.REDIRECTION_URL_PREFIX = environment.apk_UAT.REDIRECTION_URL_PREFIX
            this.EAPPS_CONTEXT_PATH = environment.apk_UAT.EAPPS_CONTEXT_PATH;
            this.EKYC_CONTEXT_PATH = environment.apk_UAT.EKYC_CONTEXT_PATH;
            this.EAPPS_URL_PREFIX = environment.apk_UAT.EAPPS_URL_PREFIX;
            this.MSG_REDIRECTION_URL_PREFIX = environment.apk_UAT.MSG_REDIRECTION_URL_PREFIX;
            this.EAPPS_RENEWAL_BULK_DOWNLOAD = environment.apk_UAT.EAPPS_RENEWAL_BULK_DOWNLOAD;
            this.MEDICARE_TPA_URL = environment.apk_UAT.MEDICARE_TPA_URL;
            this.PARAMOUNT_TPA_URL = environment.apk_UAT.PARAMOUNT_TPA_URL;
            this.VCONNECT_CONTEXT_PATH = environment.apk_UAT.VCONNECT_CONTEXT_PATH;
            this.VCONNECT_BACKEND_URL_PREFIX = environment.apk_UAT.VCONNECT_BACKEND_URL_PREFIX;
            this.IPOLICY_BACKEND_URL_PREFIX = environment.apk_UAT.IPOLICY_BACKEND_URL_PREFIX;
            this.D2C_CONTEXT_PATH = environment.apk_UAT.D2C_CONTEXT_PATH;
            this.D2C_BACKEND_URL_PREFIX = environment.apk_UAT.D2C_BACKEND_URL_PREFIX;
            this.CHAT_BOT_URL = environment.apk_UAT.CHAT_BOT_URL;
            this.COMMERCIAL_URL = environment.apk_UAT.COMMERCIAL_URL;
            this.EKYC_URL_PREFIX = environment.apk_UAT.EKYC_URL_PREFIX;
            this.encryptionReq = true;
            this.isEncryption = 'Yes';
            this.D2C_ONPREMISE_CONTEXT_PATH = environment.apk_UAT.D2C_ONPREMISE_CONTEXT_PATH;
            this.D2C_ONPREMISE_BACKEND_URL_PREFIX = environment.apk_UAT.D2C_ONPREMISE_BACKEND_URL_PREFIX;
            this.PAYMENTGW = environment.apk_UAT.PAYMENTGW;
            // this.BACKEND_URL_PREFIX = environment.apk_UAT.BACKEND_URL_PREFIX;
            this.NEXUS_PORTAL_URL = environment.apk_UAT.NEXUS_PORTAL_URL;
            this.IPOLICYV2_URL_PREFIX = environment.apk_UAT.IPOLICYV2_URL_PREFIX;
            this.CPM_URL = environment.apk_UAT.CPM_URL;
            this.IS_MOBILE_CLEVERTAP_ENABLE = true;
            this.EPICX_AI_URL = environment.apk_UAT.EPICX_AI_URL;
        }
        }
        if (environment["DD_RUM_CLIENT_TOKEN"]) {
            this.RUM_DATADOG["CLIENT_TOKEN"] = environment["DD_RUM_CLIENT_TOKEN"];
          }
          if (environment["DD_RUM_APPLICATION_ID"]) {
            this.RUM_DATADOG["APPLICATION_ID"] = environment["DD_RUM_APPLICATION_ID"];
          }
          if (environment["DD_RUM_SITE"]) {
            this.RUM_DATADOG["SITE"] = environment["DD_RUM_SITE"];
          }
          if (environment["DD_RUM_SERVICE"]) {
            this.RUM_DATADOG["SERVICE"] = environment["DD_RUM_SERVICE"];
          }
          if (environment["DD_RUM_ENV"]) {
            this.RUM_DATADOG["ENV"] = environment["DD_RUM_ENV"];
          }
          if (environment["DD_RUM_PRIVACY_LEVEL"]) {
            this.RUM_DATADOG["PRIVACY_LEVEL"] = environment["DD_RUM_PRIVACY_LEVEL"];
          }
          if (environment["DD_RUM_ALLOWED_URLS"]) {
            this.RUM_DATADOG["ALLOWED_URLS"] = environment["DD_RUM_ALLOWED_URLS"];
          }
    //     if(this.selectedEnv == 'apk_LIVE'){
    //       this.CONTEXT_PATH = environment.apk_LIVE.CONTEXT_PATH;
    //       this.REDIRECTION_URL_PREFIX = environment.apk_LIVE.REDIRECTION_URL_PREFIX
    //       this.EAPPS_CONTEXT_PATH = environment.apk_LIVE.EAPPS_CONTEXT_PATH;
    //       this.EKYC_CONTEXT_PATH = environment.apk_LIVE.EKYC_CONTEXT_PATH;
    //       this.EAPPS_URL_PREFIX = environment.apk_LIVE.EAPPS_URL_PREFIX;
    //       this.MSG_REDIRECTION_URL_PREFIX = environment.apk_LIVE.MSG_REDIRECTION_URL_PREFIX;
    //       this.EAPPS_RENEWAL_BULK_DOWNLOAD = environment.apk_LIVE.EAPPS_RENEWAL_BULK_DOWNLOAD;
    //       this.MEDICARE_TPA_URL = environment.apk_LIVE.MEDICARE_TPA_URL;
    //       this.PARAMOUNT_TPA_URL = environment.apk_LIVE.PARAMOUNT_TPA_URL;
    //       this.VCONNECT_CONTEXT_PATH = environment.apk_LIVE.VCONNECT_CONTEXT_PATH;
    //       this.VCONNECT_BACKEND_URL_PREFIX = environment.apk_LIVE.VCONNECT_BACKEND_URL_PREFIX;
    //       this.IPOLICY_BACKEND_URL_PREFIX = environment.apk_LIVE.IPOLICY_BACKEND_URL_PREFIX;
    //       this.D2C_CONTEXT_PATH = environment.apk_LIVE.D2C_CONTEXT_PATH;
    //       this.D2C_BACKEND_URL_PREFIX = environment.apk_LIVE.D2C_BACKEND_URL_PREFIX;
    //       this.CHAT_BOT_URL = environment.apk_LIVE.CHAT_BOT_URL;
    //       this.COMMERCIAL_URL = environment.apk_LIVE.COMMERCIAL_URL;
    //       this.EKYC_URL_PREFIX = environment.apk_LIVE.EKYC_URL_PREFIX;
    //       this.encryptionReq = true;
    //       this.isEncryption = 'Yes';
    //       this.D2C_ONPREMISE_CONTEXT_PATH = environment.apk_LIVE.D2C_ONPREMISE_CONTEXT_PATH;
    //       this.D2C_ONPREMISE_BACKEND_URL_PREFIX = environment.apk_LIVE.D2C_ONPREMISE_BACKEND_URL_PREFIX;
    //       this.PAYMENTGW = environment.apk_LIVE.PAYMENTGW;
    //       this.BACKEND_URL_PREFIX = environment.apk_LIVE.BACKEND_URL_PREFIX;
    //       this.NEXUS_PORTAL_URL = environment.apk_LIVE.NEXUS_PORTAL_URL;
    //       this.IPOLICYV2_URL_PREFIX = environment.apk_LIVE.IPOLICYV2_URL_PREFIX;
    //   }
    }
    //public ILUSERDTO: ILUserDetails = sessionStorage.getItem("currentILUserDTO") ? JSON.parse(atob(sessionStorage.getItem("currentILUserDTO"))) : null;
    public ILUSERDTO: ILUserDetails = JSON.parse(sessionStorage.getItem("currentILUserDTO"));
    public USER: IUser = JSON.parse(sessionStorage.getItem("currentUser"));
    public USERDTO: userDetails = JSON.parse(sessionStorage.getItem("currentUserDTO"));
    public APIKEYDTO: APIKeyDetails = JSON.parse(sessionStorage.getItem("apiKeyDTO"));
    public roleModules: RoleModules = JSON.parse(sessionStorage.getItem("roleModules"));
    public dashBoardStartDate = sessionStorage.getItem("dashBoardStartDate");
    public dashBoardEndDate = sessionStorage.getItem("dashBoardEndDate");
    public dashBoardAgencyCode = sessionStorage.getItem("dashBoardAgencyCode");
    public dashBoardAgencyType = sessionStorage.getItem("dashBoardAgencyType");
    public dashBoardFilterAgentCode = sessionStorage.getItem("dashBoardFilterAgentCode");
    public dashBoardFilterADOCode = sessionStorage.getItem("dashBoardFilterADOCode");
    public dashBoardFilterManagerCode = sessionStorage.getItem("dashBoardFilterManagerCode");
    public dashBoardFilterClusterCode = sessionStorage.getItem("dashBoardFilterClusterCode");
    public dashBoardPR = sessionStorage.getItem("dashBoardPR");
    public minYear: number = 1900;
    public maxYear: number = 2100;
    public kycDocTypes: string[] = ["Aadhaar","PanCard"];
    public status: string[] = ["Scheduled","Cancelled","Completed"];
    public durationObj: any[] = [{key:"30",value :"Less Than 30 Min"},{key:"60",value :"60"},{key:"90",value :"90"},{key:"120",value :"120"}];
    public reviewMonths: string[] = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    public reviewWeekKeyValue: any[] = [{key:"1",value :"Weekly cycle (1-7)"},{key:"2",value :"Weekly cycle (8-15)"},{key:"3",value :"Weekly cycle (16-22)"},{key:"4",value :"Weekly cycle (23-30/31)"}];
    public reviewMonthsKeyValue: any[] = [{key:"1",value :"January"},{key:"2",value :"February"},{key:"3",value :"March"},{key:"4",value :"April"},{key:"5",value :"May"},{key:"6",value :"June"},{key:"7",value :"July"},{key:"8",value :"August"},{key:"9",value :"September"},{key:"10",value :"October"},{key:"11",value :"November"},{key:"12",value :"December"}];
    public reviewShortMonthsKeyValue: any[] = [{key:0,value :"Jan"},{key:1,value :"Feb"},{key:2,value :"Mar"},{key:3,value :"Apr"},{key:4,value :"May"},{key:5,value :"Jun"},{key:6,value :"Jul"},{key:7,value :"Aug"},{key:8,value :"Sep"},{key:9,value :"Oct"},{key:10,value :"Nov"},{key:11,value :"Dec"}];
    public reviewYears: any[] = [this.today.getFullYear(),this.today.getFullYear()-1,this.today.getFullYear()-2,this.today.getFullYear()-3,this.today.getFullYear()-4,this.today.getFullYear()-5,this.today.getFullYear()-6,this.today.getFullYear()-7,this.today.getFullYear()-8,this.today.getFullYear()-9];
    public kycAdminStatus: string[] = ["Approved","Rejected","Pending"];
    public APPROVED: string = 'Approved';
    public REJECTED: string = 'Rejected';
    public PENDING: string = 'Pending';
    public POSTED: string = 'Posted';
    public MOTORPENDING: string = 'Motor Pending';
    public MOTORCOMPLETED: string = 'Motor Completed';
    public CANCELLED: string = 'Cancelled';
    public DELETE: string = 'Delete';
    public AGENT: string = 'Agent';
    public DEALER: string = 'Dealer';
    public BROKER: string = 'Broker';
    public POS: string = 'POS';
    public ADO: string = 'ADO';
    public MANAGER: string = 'Manager';
    public CLUSTERHEAD: string = 'ClusterHead';
    public CHANNELHEAD: string = 'ChannelHead';
    public TRAININGCOORDINATOR: string = 'TRAININGCOORDINATOR';
    public TRAININGMANAGER: string = 'TRAININGMANAGER';
    public CENTRALCOORDINATOR: string = 'CENTRALCOORDINATOR';
    public GENERAL_CENTRALCOORDINATOR: string = 'GENERAL_CENTRALCOORDINATOR';
    public CHANNELCOORDINATOR: string = 'CHANNELCOORDINATOR';
    public RECRUITMENTTEAM: string = 'RECRUITMENTTEAM';
    public STATEHEAD: string = 'StateHead';
    public MASTERADMIN: string = 'MASTER_ADMIN';
    public SFEMPLOYEE: string = 'SF_Employee';
	public SFBRANCHMANAGER: string = 'SF_Branch_Manager';
	public SFCLUSTERMANAGER: string = 'SF_Cluster_Manager';
	public SFREGIONALMANAGER: string = 'SF_Regional_Manager';
	public SFCORPORATEOFFICE: string = 'SF_Corporate_Office';
    public serviceRequestTypes: string[] = ["Customer Request","Agent Request"];
    public serviceRequestStatus: any[] = [{key:'Created',value:'Service Request Created'},{key:'Completed',value: 'Service Request Completed'}];
    public meetingTypes: string[] = ["Review Meeting","Direct Meeting with Customer by ADO","Meeting the Customer Along with Agent","Meetings with Prospect", "Meeting with Dealer"];
    public newsType: string = "Royal Sundaram News";
    public backpaper: string = "BACKPAPER";
    public infoPending: string = "INFOPENDING";
    public cheque: string = "CHEQUE";
    public renewal: string = "RENEWAL";
    public transactionType: string[] = ["New Business","Renewal","Rollover"];
    public reviewMeeting: string = "Review Meeting";
    public meetingByADO: string = "Direct Meeting with Customer by";
    public meetingWithAgent: string = "Meeting the Customer Along with Agent";
    public meetingWithDealer: string = "Meeting with Dealer";
    public retlOptions: string[]= ["1st Cycle Jan","2nd Cycle Jan","1st Cycle Feb","2nd Cycle Feb","1st Cycle Mar","2nd Cycle Mar","1st Cycle Apr","2nd Cycle Apr","1st Cycle May","2nd Cycle May","1st Cycle Jun","2nd Cycle Jun","1st Cycle Jul","2nd Cycle Jul","1st Cycle Aug","2nd Cycle Aug","1st Cycle Sep","2nd Cycle Sep","1st Cycle Oct","2nd Cycle Oct","1st Cycle Nov","2nd Cycle Nov","1st Cycle Dec","2nd Cycle Dec"];
    public retlOptions2021: string[]= ["Jan","Feb","Mar","Apr","1st Cycle May","2nd Cycle May","1st Cycle Jun","2nd Cycle Jun","1st Cycle Jul","2nd Cycle Jul","1st Cycle Aug","2nd Cycle Aug","1st Cycle Sep","2nd Cycle Sep","1st Cycle Oct","2nd Cycle Oct","1st Cycle Nov","2nd Cycle Nov","1st Cycle Dec","2nd Cycle Dec"];
    public otherOptions: string[]= ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    public monthNumber: any= {"Jan":1,"Feb":2,"Mar":3,"Apr":4,"May":5,"Jun":6,"Jul":7,"Aug":8,"Sep":9,"Oct":10,"Nov":11,"Dec":12};
    public meetingWithProspect: string = "Meetings with Prospect";
    public prospectSource: string[]= ["Walk In","Referral","Self","Recruitment Drive","Other"];
    public prospectInputStatus: string[]= ["Interested","Dropped","Reschedule"];
    public meetingInterested:string[]=["Yes","No"];
    public prospectProcessType: string[]= ["NSTP","STP"];
    public prospectProductCat: string[]= ["A&H"];
    public prospectProducts: string[]= ["AME","ALS"];
    public prospectDropReason: string[]= ["Not Interested","Others","Will Consider Later"];
    public prospectRescheduleReason: string[] = ["On Leave","Holiday","Prospect Unavailable","Prospect UN Contactable","On Prospect Request","Unplanned Urgency","Unplanned Meeting in Office","Others"];
    public prospectIdProofDocs: string[] = ["Passport","License","Aadhaar","Pan","Voter"];
    public prospectCertificateDocs: string[] = ["Master Certificate","Degree Certificate","Marks Card Proof"];
    public prospectExperiencecDocs: string[] = ["Experience Letter Proof","Relieving Letter Proof"];
    public NO_RECORDS_FOUND:string = "No Records Found";
    public DEFAULT_SEARCH_TYPE: string = "home";
    public TRAINING_SCHEDULE: string[] = ["Special Training","Monthly Training"];
    public EXAMINATION_SOURCE: string[] = ["Recruitment Drive","Referral","Self","Walk In","Other"];
    public PDF_FILE_EXTENSION: string[] = ['pdf', 'PDF'];
    public EXCEL_FILE_EXTENSION: string[] = ['xlsx', 'xls', 'csv','XLSX', 'XLS', 'CSV'];
    public BC_EXCEL_FILE_EXTENSION: string[] = ['xlsx', 'xls', 'xlsb', 'csv','XLSX', 'XLS', 'CSV', 'XLSB'];
    public IMAGE_FILE_EXTENSION: string[] = ['jpeg', 'jpg', 'gif', 'bmp', 'png', 'JPEG', 'JPG', 'GIF', 'BMP', 'PNG'];
    public MSG_FILE_EXTENSION: string[] = ['msg', 'MSG'];
    public LICENCE_SEARCH_TYPES: any[] = [{key:'code',value:'Intermediary Code'},{key:'name',value: 'Intermediary Name'}];
    public INTERMEDIATORY_TYPE: any[] = [{key:'A',value:'Agent'},{key:'B',value: 'Broker'},{key:'D',value: 'Dealer'},{key:'C',value: 'Corporate Agent'},{key:'POS',value: 'POS'}];
    public INTERMEDIATORY_TYPE_LIST: any[] = [{key:'Agent',value:'Agent'},{key:'Broker',value: 'Broker'},{key:'Dealer',value: 'Dealer'},{key:'Corporate Agent',value: 'Corporate Agent'},{key:'POS',value: 'POS'}];
    public EDUCATION_QUALIFICATION_LIST: string[] = ['SSLC','HSC','Diploma','UG','PG'];
    public maritalstatus: string[] = ['Married','UnMarried']
    public INDIAN_STATES: string[] = ['Andaman and Nicobar','Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chandigarh','Chattisgarh','Dadra and Nagar Haveli','Daman and Diu','Delhi','Goa','Gujarat','Haryana','Himachal Pradesh','Jammu and Kashmir','Jharkhand','Karnataka','Kerala','Lakshadweep','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Puducherry','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal']
    public REGION_CODES: any[] = [{key:'C',value:'Corporate'},{key:'N',value:'North'},{key:'W',value:'West'},{key:'E',value:'East'},{key:'S',value:'South'}];
    public ITEMS_TO_FOLLOWUP_UPLOAD_TYPES: string[] = ['BackPaper Pendency','InfoPending','ChequeNotDeposited'];
    public kycDocTypess: string[] = ["Aadhaar","PanCard","Aadhar"];
    // public ADMIN_USERS: string[] = ["admin",this.TRAININGCOORDINATOR,this.TRAININGMANAGER,this.CENTRALCOORDINATOR,this.CHANNELCOORDINATOR,this.RECRUITMENTTEAM,this.MASTERADMIN,this.GENERAL_CENTRALCOORDINATOR,"Motor_UW","Motor_Support","Motor_UW_VIR"];
    public UPLOAD_YEARS: any[] = [this.today.getFullYear(), this.today.getFullYear()-1];
    public COMMISSION_UPLOAD_YEARS: any[] = [this.today.getFullYear(),this.today.getFullYear()-1,this.today.getFullYear()-2,this.today.getFullYear()-3,this.today.getFullYear()-4,this.today.getFullYear()-5];
    public MOTOR_PRODUCTS: any[] = ["StandaloneCPA","CommercialGoodsComprehensive","CommercialGoodsLiabilityOnly","MiscellaneousVehiclePackage","MiscellaneousVehicleLiabilityOnly","PassengerCarryingComprehensive","PassengerCarryingLiabilityOnly","VPC_Comprehensive","VPC_LiabilityOnly","MotorCyclePackage","MotorCycleLiabilityOnly"];
    public MOTOR_PRODUCTS_CODE: any[] = ["VGC","VOC","VPCV","VPC","VMC","VPA"];
    public NATURE_OF_LOSS: any[] = ["Accident","Fire","Flood","Partial Theft","Theft"];
    public CURRENT_VEHICLE_LOCATION: any[] = ["Police Station","Repairer","Residence","Spot","Others"];
    public DRIVER_RELATIONSHIP: any[] = ["Daughter","Family Members","Friends","Relatives","Self","Spouse","Son","Paid driver","Others"];
    public CLAIM_UPLOAD_DOC: any[] = ["Driving Licence","Duly filled and signed Claim Form","Policy Copy","RC Book","Satisfaction Voucher","Original Bills / Cash Bills / Credit Invoice"];
    public BASIC_QUALIFICATION: any[] = ["Class X", "Class XII", "Graduate", "Post Graduate"];
    public IDB_CATEGORY: any[] = ["GEN", "SC", "ST", "OBC"];
    public PRODUCT_CATEGORY: any[] = ["Motor", "Health", "Commercial"];
    public LOB: any[] = ["All","Motor", "Health"];
    public PROSPECT_CHC_REPORTS_TYPE: any[] = ["Prospect Interium Code Created", "Prospect Pending", "Prospect Permanent Code Created"];
    public REPORTING_TO_TYPES: any[] = [{key:'AGENT',value:'ADO'},{key:'Agent',value:'ADO'},{key:'Broker',value: 'ADO'},{key:'Dealer',value: 'ADO'},{key:'Corporate Agent',value: 'ADO'},{key:'POS',value: 'ADO'},{key:'A',value:'ADO'},{key:'B',value: 'ADO'},{key:'D',value: 'ADO'},{key:'C',value: 'ADO'},{key:'POS',value: 'ADO'},{key:'ADO',value: 'Manager'},{key:'Manager',value: 'ClusterHead'},{key:'ClusterHead',value: 'ChannelHead'},{key:'SF_Employee',value: 'SF_Branch_Manager'},{key:'SF_Branch_Manager',value: 'SF_Cluster_Manager'},{key:'SF_Cluster_Manager',value: 'SF_Regional_Manager'},{key:'SF_Regional_Manager',value: 'SF_Corporate_Office'}];
    public PROSPECT_FEE_TYPES: any[] = ["Waiver","Pay"];
    public CALLS_TYPE: any[] = [{key: 'Agent', value: 'Call with Agent'},{key: 'Dealer', value: 'Call with Dealer'}];
    public CATEGORY_VALUES: any[] = ["Price Related", "Claims Related", "Marketing Expenses", "Other Service Related"];
    public RELATION_SHIP: string[] = ["AUNT","BROTHER","BROTHER IN LAW","COUSIN","DAUGHTER","DAUGHTER IN LAW","EMPLOYEE","EMPLOYER","FATHER","FATHER IN LAW","GRAND MOTHER","GRAND FATHER","GRAND DAUGHTER","GRAND SON","HUSBAND","LEGAL GUARDIAN","MOTHER","MOTHER IN LAW","NEPHEW","NIECE","OTHERS","SELF","SISTER","SISTER IN LAW","SON","SON IN LAW","SPOUSE","UNCLE","WIFE"];
    public RETL_CHANNEL: string = "RETL";
    public OEM_CHANNEL: string = "OEM";
    public RETAIL_CHANNEL: string = "RETAIL";
    public BRANCH_OPPORTUNITY: string = "Opportunity";
    public BRANCH_PRIORITY: string = "Priority";
    public WhichEmi:string[]=["1st EMI Due","2nd EMI Due","3rd EMI Due","4th EMI Due","5th EMI Due","6th EMI Due","7th EMI Due","8th EMI Due","9th EMI Due","10th EMI Due","11th EMI Due","12th EMI Due"];
    public RetailInputStatus: string[]= ["Activation Status","Yet to Activate"];
    public BrokerPresenceList: string[]= ["Pan India","East","West","North","South","Others"];
    public FORM_1A_1B_TITLE: any[] = [{key:'1',value:'Mr.'},{key:'2',value:'Mrs.'},{key:'3',value: 'Miss'}];
    public TO_ADDRESS1: string = "Royal Sundaram General Insurance Co. Limited";
    public TO_ADDRESS2: string = "Corporate Office, Vishranthi Melaram Towers";
    public TO_ADDRESS3: string = "No.2/319, Rajiv Gandhi Salai(OMR)";
    public TO_DISTRICT: string = "Karapakkam";
    public TO_STATE: string = "Tamilnadu";
    public TO_CITY: string = "Chennai";
    public TO_PINCODE: string = "600097";
    public TO_TEL: string = "Tel : +91 (0)44 7117 7117";
    public TO_FAX: string = "Fax : 91-44-7113 7114";
    public OperationDetailsUploadType: string[]= ["Cheque Bounce","NCB Recovery","NCB Truncation","TL / SL cancellation","Pro-rata cancellation","Short term cancellation","Endorsements"];
    public commissionTypeList: any[] = [{ name: 'Broker', code: 'Broker' },{ name: 'Corporate Agent and IMF', code: 'Corporate Agent and IMF' },{ name: 'MISP', code: 'MISP' }];
    public GLOBALS_SEARCH_OPTION: any[] = ["Print Policy","Health Card Download"];
    public PRODUCT_LOB: string[] = ["Health","Motor"];
    public callWithProspect: string = "Call with Prospect";
    public callWithCustomerAgent: string = "Call the Customer Along with Agent";
    public callWithAgent: string = "Call with Agent";
    public receiptOrWaiver: any = [ { key:'Receipt' , value: 'Receipt'},{ key:'Waiver',value: 'Waiver' }];
    public CLEAR_SESSION_MENU_ITEMS: string[] = ["/virtual-menu"];
    public virVehicleType: string[] = ["New Series","Bharat Series"];
    public virCamComVehicleType: string[] = ["Old","New Series","Bharat Series"];
    public previousMobileAppVersion: string = "18";
    public commissionFrequencyList : string[]= ["Monthly","Fortnightly","Weekly","Daily"];
    public balanceCommsionFrequencyList: string [] = ["Monthly","Quarterly","Half-Yearly","Yearly"];
    public bcQuaterlyList: any  = [{ start: 'APR', end: 'JUN' },
    { start: 'JUL', end: 'SEP' },
    { start: 'OCT', end: 'DEC' },
    { start: 'JAN', end: 'MAR' }]
    public BC_UPLOAD_YEARS: any[] = [this.today.getFullYear(), this.today.getFullYear() - 1, this.today.getFullYear() - 2];
    public monthMapping: { [key: string]: string } = {
        "Jan": "January",
        "Feb": "February",
        "Mar": "March",
        "Apr": "April",
        "May": "May",
        "Jun": "June",
        "Jul": "July",
        "Aug": "August",
        "Sep": "September",
        "Oct": "October",
        "Nov": "November",
        "Dec": "December"
    };
public OLD_BALANCE_STATEMENT_PROPS : any[]= ["AGENT CODE", "AG Code", "AGENT NAME", "POLICY REGION NAME",
"POLICY BRANCH NAME", "AGENT LICENSE EXPIRY DATE", "POLICY ID", "TYPE OF BUSINESS", "CLIENT NAME", "POLICY ENTRY DATE",
"COINSURANCE TYPE", "COINSURANCE FLAG", "FLOOR RATE APPLICABLE", "COINSURANCE SHARE", "CO BROKING SHARE",
"ENDORSEMENT ID", "TRANSACTION ID", "Primary ID", "PREMIUM ENTRY DATE", "PREMIUM EFFECTIVE DATE",
"PRODUCT CODE", "RIDER CODE", "LINE OF BUSINESS", "PRODUCT CATEGORY 1", "PRODUCT CATEGORY 2", "CAMPAIGN CODE",
"NR FLAG", "FREQUENCY", "DISCOUNT PERCENTAGE", "GROSS WRITTEN PREMIUM", "BASE PREMIUM",
"TOTAL PREMIUM", "MANUAL COMMISSION RATE", "COMMISSION RATE", "COMMISSION AMOUNT", "REMARKS", "CHANNEL_V24", "CHANNEL", "SUBCHANNEL",
"BRANCH CODE","BRANCH NAME","CLUSTER DISPLAY", "CYCLE", "MONTH", "SEQUENCE",
"STATUS", "PAID DATE", "ALM", "INV NO", "INV DATE", "UTR NO", "PAN NO"];

public NEW_BALANCE_STATEMENT_PROPS : any[] = ["POLICY ID", "PRIMARY ID", "POLICY ENTRY DATE", "PREMIUM ENTRY DATE",
"PREMIUM EFFECTIVE DATE", "TYPE OF BUSINESS", "CLIENT NAME", 
"COINSURANCE TYPE", "COINSURANCE FLAG", "COINSURANCE SHARE", "CO-BROKING SHARE",
"LINE OF BUSINESS","PRODUCT CODE", "PRODUCT CATEGORY 1", "PRODUCT CATEGORY 2", "A/H INSURED AGE","CAMPAIGN CODE","FREQUENCY",
"INSTALLMENT NUMBER","LONG TERM YEAR","RTO STATE","VEHICLE AGE","VEHICLE SEATING/CAPACITY",
"VEHICLE MAKE","VEHICLE MODEL","RTO REVISED CITY","VEHICLE TONNAGE",
"VEHICLE TYPE","FUEL/CUBIC CAPACITY","FUEL TYPE","VEHICLE REGISTRATION NUMBER",
"TECHNICAL DISCOUNT","FINAL DISCOUNT","GROSS WRITTEN PREMIUM","ADD ON PREMIUM",
"OD / BASE PREMIUM","TP PREMIUM","TERRORISM PREMIUM","TOTAL BASE PREMIUM",
"TERRORISM TOTAL PREMIUM","TOTAL PREMIUM REST ALL","TERRORISM MANUAL COMMISSION RATE",
"MANUAL COMMISSION RATE REST ALL","RATE - ADD ON","RATE - OD / BASE",
"RATE - TP","RATE - TERRORISM","COMMISSION - ADD ON","COMMISSION - OD / BASE",
"COMMISSION - TP","COMMISSION - TERRORISM","TOTAL COMMISSION","REMARKS",
"CHANNEL V24","SUB CHANNEL","BRANCH CODE","BRANCH NAME","CLUSTER DISPLAY", "CYCLE", "MONTH", "SEQUENCE",
"STATUS", "PAID DATE", "ALM", "INV NO", "INV DATE", "UTR NO", "PAN NO"];
    public keyPressAlphanumeric(event) {
        var inp = String.fromCharCode(event.keyCode);
        if (/[a-zA-Z0-9 ]/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    encoder(str) {
        //let encoder = new TextEncoder();
        //let byteArray = encoder.encode(str)
        return CryptoJS.enc.Utf8.parse(str)
    }

    toWordArray(str) {
        return CryptoJS.enc.Utf8.parse(str);
    }

    public encrypt(value) {
        var key = CryptoJS.PBKDF2(this.PASSWORD, this.SALT, {
            keySize: 128 / 32,
            iterations: 65536
        })
        var encrypted = CryptoJS.AES.encrypt(this.encoder(value), key, {
            iv: this.toWordArray(this.Key_IV),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        })
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }

    public decrypt(value) {
        var key = CryptoJS.PBKDF2(this.PASSWORD, this.SALT, {
            keySize: 128 / 32,
            iterations: 65536
        })
        var decrypted = CryptoJS.AES.decrypt(value, key, {
            iv: this.toWordArray(this.Key_IV),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        })
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    public getEappsJwtToken() {
        if (sessionStorage.getItem('currentILUserDTO')) {
            let loginTime = moment(new Date()).format('HH:mm:ss');
            let jwt = this.encrypt("1WE49RX~" + JSON.parse(sessionStorage.getItem('currentILUserDTO')).loginId + "~" + loginTime + "~XR94EW1");
            sessionStorage.setItem("logintime", moment(new Date()).format('DD/MM/YYYY HH:mm:ss'));
            sessionStorage.setItem("JWT", jwt)
            return jwt;
        }
    }

  public getAuthenticatedUrls(): Map<string, string> {
     const urlMap = new Map<string, string>();
     if (this.BACKEND_URL_PREFIX?.trim()) {
         urlMap.set(this.BACKEND_URL_PREFIX.trim() + this.CONTEXT_PATH, 'ILounge');
        }
      return urlMap;
   }

    public getOAuth2TokenVariable(url?: string): string {       
        return 'OAUTH2_ROYALSUNDARAM';  
    }

    vConnectEncryptAndEncode(raw: string): Promise<string> {
        const keyBytes = this.base64ToBytes(this.VCONNECT_SHARED_KEY);
        const ivBytes = this.base64ToBytes(this.VCONNECT_Key_IV);
        return crypto.subtle.importKey(
            "raw",
            keyBytes,
            { name: "AES-CBC" },
            false,
            ["encrypt"]
        )
            .then(cryptoKey => {
                const encoder = new TextEncoder();
                const rawBytes = encoder.encode(raw);

                return crypto.subtle.encrypt(
                    { name: "AES-CBC", iv: ivBytes },
                    cryptoKey,
                    rawBytes
                );
            })
            .then(encBuffer => {
                const encBytes = new Uint8Array(encBuffer);
                return this.bytesToBase64(encBytes);
            })
            .catch(e => {
                console.error("encryptAndEncode error:", e);
                return null as unknown as string;
            });
    }

    vConnectDecodeAndDecrypt(base64Cipher: string): Promise<string> {
        const keyBytes = this.base64ToBytes(this.VCONNECT_SHARED_KEY);
        const ivBytes = this.base64ToBytes(this.VCONNECT_Key_IV);
        const encryptedBytes = this.base64ToBytes(base64Cipher);
        return crypto.subtle.importKey(
            "raw",
            keyBytes,
            { name: "AES-CBC" },
            false,
            ["decrypt"]
        )
            .then(cryptoKey => {
                return crypto.subtle.decrypt(
                    { name: "AES-CBC", iv: ivBytes },
                    cryptoKey,
                    encryptedBytes
                );
            })
            .then(decBuffer => {
                const decoder = new TextDecoder();
                return decoder.decode(decBuffer);
            })
            .catch(e => {
                console.error("decodeAndDecrypt error:", e);
                return null as unknown as string;
            });
    }

    base64ToBytes(base64: string): Uint8Array {
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    }

    bytesToBase64(bytes: Uint8Array): string {
        let binary = "";
        for (let i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }
  secureRandom(): number {
    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    return array[0] / (0xffffffff + 1);
  }
  
}
